module.exports = __webpack_public_path__ + "static/media/g2.3ee66aa5.jpg";